export const masterDataToSelectCatalog = (masterDataElement) => ({
  itemValue: masterDataElement.value,
  itemLabel: masterDataElement.value,
});

export const masterDataToSelectCatalogItem = (masterDataElement) => masterDataElement.value;

export const masterDataToCheckboxCatalog = (masterDataElement) => ({
  value: masterDataElement.id,
  title: masterDataElement.value,
});
